<template>
  <div class="pageContent">
    <div class="reportList">
      <van-notice-bar scrollable text="温馨提示：本服务提供的资料仅供快捷浏览，报告内容以纸质报告为准，如需医学判断，请咨询医生。" />
      <div class="total">
        <span>您当前共有{{total}}份检查结果</span>
        <!-- <span class="return" @click="toSelect"> -->
          <!-- <van-icon name="plus" @click="toSelect" /> -->
          
        <!-- </span> -->
        <div class="return" @click="toSelect()">添加新报告</div>
      </div>
      <ReportResult
        :listData="listData"
        @getReportInfo="getReportInfo"
        @getWechatPay="getWechatPay"
        @callReportPrint="callReportPrint"
        @getUnBind="getUnBind"
        @moreFn="moreFn"
        @emailShowFn="emailShowFn"
      />
    </div>
    <van-dialog v-model="emailShow" show-cancel-button confirm-button-color="#409eff" :before-close="beforeClose">
      <input class="email-input" placeholder="请输入邮箱号" v-model="emailValue" label="邮箱" />
    </van-dialog>
  </div>
</template>

<script>
import ReportResult from "@/components/reportList/reportResult";
import {
  getAllReport,
  getReportInfo,
  ready2pay,
  getLocalReport,
  getUnBind,
  sendEmail
} from "@/api/report";
import Storage from "@/tools/storage";
import wx from "weixin-js-sdk";
import axios from "axios";
import { Dialog,Notify } from "vant";
export default {
  name: "reportList",
  components: { ReportResult,[Dialog.Component.name]: Dialog.Component },
  data() {
    return {
      listData: [],
      total: 0,
      nobind: true,
      emailShow: false,
      emailValue: '',
      studyId:''
    };
  },
  methods: {
    async sendEmailFn(done){
      try{
        let res = await sendEmail({ study_id: this.studyId, email: this.emailValue});
        console.log(res)
        if (res) {
          this.emailValue = ''
          done()
          Notify({ type: 'success', message: '影像正在打包处理中，请稍后到指定邮箱查看', duration: 2000, })
        }
      }catch(err){
        console.log(err)
      }
      
    },
    emailShowFn(data){
      this.emailShow = data.value
      this.studyId = data.studyId
    },
    beforeClose(action,done) {
      if(action === 'confirm'){
        let reg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/;
        if (reg.test(this.emailValue)) {
          this.sendEmailFn(done)
        } else {
          this.emailShow = true
          console.log(this.emailShow)
          Notify({ type: 'danger', message: '请输入正确的邮箱号' })
          done(false) 
        }
      }else{
        done()
      }
    },
    // confirm(){
    //   if (reg.test(this.emailValue)) {
    //     this.emailShow = false
    //   } else {
    //     this.emailShow = true
    //     console.log(this.emailShow)
    //     Notify({ type: 'danger', message: '请输入正确的邮箱号' })
    //   }
    // },
    async getAllReport() {
      let res = await getAllReport({ phone: Storage.get("phone") });
      if (res) {
        this.listData = res;
        this.total = res.length;
      }
    },
    async getReportInfo(params, fromValue) {
      Storage.set("examId", params.exam_id);
      let res = await getReportInfo(params);
      if (res) {
        Storage.set("reportInfo", res);
        Storage.set('fromValue', fromValue)
        this.$router.push({
          path: "/reportInfo/report"
        });
      }
    },
    //解绑
    moreFn(index) {
      this.listData = this.listData.map((item, i) => {
        if (index == i) {
          if (item.nobind) {
            return {
              ...item,
              nobind: false
            };
          } else {
            return {
              ...item,
              nobind: true
            };
          }
        } else {
          return {
            ...item,
            nobind: !this.nobind
          };
        }
      });
    },
    getUnBind(item) {
      Dialog.confirm({
        title: "解绑",
        message: "确定解绑当前检查？",
        cancelButtonText: "取消",
        confirmButtonText: "确定解绑"
      })
        .then(() => {
          this.getUnBindFn(item)
        })
        .catch(() => {
          this.getAllReport();
        });
    },
    async getUnBindFn(item){
      let res = await getUnBind({ exam_id: item.exam_id, phone: Storage.get("phone")});
      if(res === 1){
        Notify({ type: 'success', message: '解绑成功', duration: 2000, })
        this.getAllReport();
      }
    },
    wechatPay() {
      let _this = this;
      axios
        .post("https://wechat.pacsonline.cn/wx_patient/api/getJsSdkConfig")
        .then(res => {
          wx.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseWXPay"]
          });
          wx.chooseWXPay({
            timestamp: _this.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: _this.nonceStr, // 支付签名随机串，不长于 32 位
            package: _this.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: _this.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: _this.paySign, // 支付签名
            success: function(res) {
              _this.getAllReport();
              // 支付成功后的回调函数
            }
          });
        });
    },
    async getWechatPay(params) {
      let res = await ready2pay(params);
      if (res) {
        this.nonceStr = res.nonceStr;
        this.package = res.package;
        this.paySign = res.paySign;
        this.signType = res.signType;
        this.timeStamp = res.timeStamp;
        this.wechatPay();
      }
    },
    async callReportPrint(item) {
      const exam_id = item.exam_id;
      const exam_status = item.exam_status;
      if (
        item.charge_mode == 1 &&
        item.pay_status == 0 &&
        item.film_price != 0
      ) {
        alert("未支付数字影像服务费,无法查看报告原件");
        return;
      } else if (
        item.charge_mode == 3 &&
        item.pay_status == 0 &&
        item.film_price != 0
      ) {
        alert("未支付数字影像服务费,请到医院缴费窗口缴费");
        return;
      } else if (exam_status !== 9 && item.report_status !== 9) {
        alert("报告未确认,无法查看报告原件");
        return;
      } else {
        this.$router.push({
          path: "/print",
          query: { exam_id: exam_id, from: "reportList" }
        });
      }
      // let res = await getLocalReport()
    },
    toSelect() {
      this.$router.push({ path: "/filmQuery" });
    }
  },
  created() {
    this.getAllReport();
    if (this.$route.params.charge_mode === true) {
      if(this.$route.params.institution_id === '13740001') {
        return alert("您已正常打印胶片，无法查看数字影像。");
      }
      alert("请支付数字影像服务费，方可查阅");
    } else {
      if (this.$route.params.isSure && this.$route.params.exam_id) {
        let params = {
          id: this.$route.params.exam_id,
          openid: Storage.get("openid")
        };
        this.getWechatPay(params);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.reportList {
  height: 100%;
  width: 100%;
  background: #eeeeee;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  color: #000;
  .total {
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 10px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    color: #000;
    .return {
      width: 85px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      line-height: 30px;
      color: #fff;
      margin-top: 5px;
      border-radius: 5px;
      background: #409eff;
    }
  }
}
.email-input{
  width: 70%;
  margin: 30px 0 15px;
  border-radius: 10px;
  padding: 10px;
  border: none;
  border-bottom: 1px solid rgb(184, 183, 183);
}
</style>
